export class ImmigrationStatusTypes {
    static readonly DRAFT = 'ImmDraft';
    static readonly PENDING ='ImmPending';
    static readonly ACCEPTED = 'ImmAccepted';
    static readonly DECLINED = 'ImmDeclined';
    static readonly INPROCESS = 'ImmInProcess';
    static readonly APPROVED = 'ImmApproved';
    static readonly REJECTED = 'ImmRejected';
    static readonly COMPLETED = 'ImmCompleted';
  static readonly ONHOLD = 'ImmOnHold';
  static readonly WITHDRAWN = 'ImmWithdrawn';
}

export class BTQueryStatusTypes {
  //static readonly DRAFT = 'Draft'
  static readonly INPROCESS = 'In Process'
  static readonly PENDING = 'Pending'
  static readonly COMPLETED = 'Completed'
  static readonly ONHOLD = 'On Hold'
  static readonly RESOLVED = 'Resolved'
  static readonly CANCELLED = 'Cancelled'
}